import { StyledButton } from './styles';

function Button({ children, ...otherProps }: any) {
    return <StyledButton {...otherProps}>{children}</StyledButton>;
}
export default Button;
